import { createAuthenticatedGabitoLogger } from '@mrkt/features/gabito';
import { getSpotifyClientId } from '@mrkt/features/env';
import { transport } from './transport';

export const logGabitoEvent = createAuthenticatedGabitoLogger({
  transport,
  clientId: getSpotifyClientId(),
});
